import { motion } from "framer-motion";

import ben from "../../accests/bentota/benn (1).jpeg"
import ben1 from "../../accests/bentota/ben (2).jpeg"
import ben2 from "../../accests/bentota/benn (3).jpeg"
import ben3 from "../../accests/bentota/benn (4).jpeg"
import ben4 from "../../accests/bentota/benn (5).jpeg"
import ben5 from "../../accests/bentota/benn (6).jpeg"

// Unsplash / example images
const heroImg =
    ben4; // Deep Sea Fishing
const fishingImg1 =
    ben2;
const fishingImg2 =
   ben3;
const fishingImg3 =
   ben1;

export default function BentotaDeepSeaFishing() {
    const highlights = [
        {
            title: "Deep Sea Fishing Adventure",
            desc: "Experience the thrill of fishing in the bountiful waters of the Indian Ocean with professional guidance.",
            img: fishingImg1,
        },
        {
            title: "Catch Game Fish",
            desc: "Try catching tuna, snapper, barracuda, and other prized ocean fish.",
            img: fishingImg2,
        },
        {
            title: "Expert Guidance",
            desc: "Learn trolling techniques and fishing tips from experienced local fishermen.",
            img: ben1,
        },
    ];

    const itinerary = [
        "Morning pickup from your hotel",
        "Arrive at Bentota Harbor for briefing and equipment setup",
        "Board the fishing boat and sail into the Indian Ocean",
        "Learn trolling techniques from professional fishermen",
        "Enjoy 4+ hours of deep sea fishing",
        "Return to harbor and share your catch stories",
        "Optional light refreshments and drinks on board",
        "Return to hotel",
    ];

    const travelTips = [
        "Best time for fishing: November to April",
        "Wear sun protection, hat, and sunglasses",
        "Bring your camera to capture your catch",
        "Light breakfast recommended before departure",
        "Motion sickness pills if prone to seasickness",
    ];

    return (
        <div className="pt-28 bg-gray-50">

            {/* HERO */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="relative h-[65vh]"
            >
                <img
                    src={heroImg}
                    alt="Bentota Deep Sea Fishing"
                    className="w-full h-full object-cover brightness-75"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-6">
                    <motion.h1
                        initial={{ y: -40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.3 }}
                        className="text-5xl md:text-6xl font-bold drop-shadow-lg"
                    >
                        Bentota Deep Sea Fishing
                    </motion.h1>
                    <motion.p
                        initial={{ y: 40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.6 }}
                        className="mt-4 max-w-3xl text-lg drop-shadow-md"
                    >
                        Embark on a thrilling fishing adventure in the Indian Ocean off the coast of Bentota.
                    </motion.p>
                </div>
            </motion.div>

            {/* HIGHLIGHTS */}
            <section  data-aos="fade-up"
                      data-aos-duration="3000" className="max-w-7xl mx-auto px-6 py-16">
                <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
                    Why Choose This Tour?
                </h2>
                <div className="grid md:grid-cols-3 gap-10">
                    {highlights.map((item, i) => (
                        <motion.div
                            key={i}
                            whileHover={{ scale: 1.05 }}
                            className="bg-white rounded-3xl shadow-lg overflow-hidden transition"
                        >
                            <img
                                src={item.img}
                                alt={item.title}
                                className="w-full h-64 object-cover"
                            />
                            <div className="p-6">
                                <h3 className="text-2xl font-semibold text-blue-500 mb-2">
                                    {item.title}
                                </h3>
                                <p className="text-gray-600 text-sm">{item.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </section>

            {/* ITINERARY */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="bg-gray-100 py-16">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-start">
                    {/* LEFT – ITINERARY LIST */}
                    <div>
                        <h2 className="text-3xl font-bold mb-10 text-gray-800">Detailed Itinerary</h2>
                        <ul className="space-y-4 text-gray-700 list-decimal list-inside">
                            {itinerary.map((step, index) => (
                                <motion.li
                                    key={index}
                                    initial={{ x: -50, opacity: 0 }}
                                    whileInView={{ x: 0, opacity: 1 }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                    className="text-lg"
                                >
                                    {step}
                                </motion.li>
                            ))}
                        </ul>
                    </div>

                    {/* RIGHT – SMALL IMAGES */}
                    <div className="grid grid-cols-2 gap-4">
                        {[ben,ben5,ben3,ben2].map((img, i) => (
                            <motion.img
                                key={i}
                                src={img}
                                alt="Fishing spot"
                                whileHover={{ scale: 1.05 }}
                                className="h-40 w-full object-cover rounded-2xl shadow-lg"
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* TRAVEL TIPS + CTA */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="relative py-24 overflow-hidden">
                <div className="absolute inset-0">
                    <img
                        src={fishingImg2}
                        alt="Fishing tour background"
                        className="w-full h-full object-cover scale-110 blur-md"
                    />
                    <div className="absolute inset-0 bg-black/60"></div>
                </div>

                <div className="relative max-w-6xl mx-auto px-6 text-white text-center">
                    <h2 className="text-3xl md:text-4xl font-bold mb-10">
                        Travel Tips
                    </h2>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {travelTips.map((tip, i) => (
                            <motion.div
                                key={i}
                                whileHover={{ scale: 1.05 }}
                                className="bg-white/90 p-6 rounded-3xl shadow-lg border border-gray-200 transition"
                            >
                                <p className="text-gray-700 text-sm">{tip}</p>
                            </motion.div>
                        ))}
                    </div>

                    {/* BOOK CTA */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="mt-14"
                    >
                        <motion.a
                            whileHover={{ scale: 1.08 }}
                            whileTap={{ scale: 0.95 }}
                            href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%20Bentota%20Deep%20Sea%20Fishing"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center px-14 py-4
        bg-blue-500 text-white font-semibold text-lg
        rounded-full shadow-xl hover:bg-blue-400
        transition-all duration-300"
                        >
                            Book Bentota Deep Sea Fishing
                        </motion.a>

                        <p className="mt-4 text-sm text-gray-200">
                            📞 Custom tours • 🕒 Flexible timing • 🚤 Comfortable boat rides
                        </p>
                    </motion.div>

                </div>
            </section>

        </div>
    );
}
